import { ResponseWrapper } from '@/api/types/base.types'

export const PODPISLON_INTEGRATION_NAME = 'podpislon' as const

export type PodpislonIntegrationFields = {
  api_key: string
  is_active: boolean
  is_connected: boolean
  last_connection_check_at: string | null
  last_connection_error: string | null
}

export type PodpislonIntegrationGetConfigData = {
  name: typeof PODPISLON_INTEGRATION_NAME
  label: string
  description: string | null
  category: 'document_signing'
  fields: PodpislonIntegrationFields
  created_at: string
  updated_at: string
}

export type PodpislonIntegrationUpdateConfigBody = {
  api_key?: string
  is_active?: boolean
}

export type PodpislonTestConnectionMeta = Pick<
  PodpislonIntegrationFields,
  'is_active' | 'is_connected' | 'last_connection_check_at' | 'last_connection_error'
>

export type PodpislonTestConnectionData = {
  status: 'success' | string
  connected: boolean
  message: string
  balance?: number
  account_info?: Record<string, unknown>
  checked_via?: 'stored_config'
  meta?: PodpislonTestConnectionMeta
}

export type IntegrationListItem = {
  name: string
  label: string
  description: string | null
  is_active: boolean
  created_at: string
  updated_at: string
}

export type IntegrationListData = Record<string, IntegrationListItem[]>

export type ResponsePodpislonIntegrationConfig =
  ResponseWrapper<PodpislonIntegrationGetConfigData>

export type ResponsePodpislonTestConnection =
  ResponseWrapper<PodpislonTestConnectionData>

export type ResponseIntegrationList = ResponseWrapper<IntegrationListData>
